import { PipelineType } from '@/types/vlm'

export type PipelineStepId =
  'name' | 'source' | 'schedule' | 'triggers' | 'actions' | 'settings'

export const PIPELINE_STEP_LABELS: Record<PipelineStepId, string> = {
  name: 'vlm.pipelines.create.step.name',
  source: 'vlm.pipelines.create.step.inputSource',
  schedule: 'vlm.pipelines.create.step.schedule',
  triggers: 'vlm.pipelines.create.step.triggers',
  actions: 'vlm.pipelines.create.step.actions',
  settings: 'vlm.pipelines.create.step.pipelineSettings'
}

const DEFAULT_STEPS: PipelineStepId[] = [
  'name',
  'source',
  'triggers',
  'actions',
  'settings'
]

const STEPS_BY_TYPE: Partial<Record<PipelineType, PipelineStepId[]>> = {
  virtual_patrol: [
    'name',
    'source',
    'schedule',
    'triggers',
    'actions',
    'settings'
  ]
}

// The type is picked on the first step, and every type shares the first two
// steps, so the active step index stays valid when the type changes.
export const getPipelineSteps = (
  pipelineType: PipelineType | ''
): PipelineStepId[] =>
  (pipelineType && STEPS_BY_TYPE[pipelineType]) || DEFAULT_STEPS
